import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    emptyProcessViewContainer: {
      display: 'flex',
      flexFlow: 'column',
      textAlign: 'center'
    },
    fontSize: {
      fontSize: '14px'
    },
    buttonWidth: {
      width: '250px'
    },
    itemMargin: {
      margin: '10px'
    }
  });
});
